var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScotty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.18 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-scotty-1{fill:#ea9f96;}.cls-scotty-2{fill:#141519;}.cls-scotty-3{fill:#614b4a;}.cls-scotty-4{fill:#e2cfd3;}.cls-scotty-5{clip-path:url(#clip-scotty-path);}.cls-scotty-6{fill:#d8908b;}.cls-scotty-7{fill:#f2e2e5;}.cls-scotty-8{fill:#f8ece9;}.cls-scotty-9{fill:#4f3c3c;}.cls-scotty-10{fill:#1c1a23;}.cls-scotty-11{fill:#f6e8ef;}.cls-scotty-12{fill:#5e4134;}.cls-scotty-13{fill:#fff;}.cls-scotty-14{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-scotty-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-1",
    d: "M174.77,95s17.08,28.58,26.31,33.68S172.9,206.9,159.3,207.38A58.41,58.41,0,0,1,134,202L156.38,98.55,165.86,84Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-2",
    d: "M74.35,535.57S59.8,629,60.77,639.06l304.32-1.94s0-51.1-6.46-60.15-58.86-71.48-58.86-71.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-3",
    d: "M65.11,533.77s85,56.63,109,64.42l16.28-31.86,37.51,36.1s77.16-38.22,94.15-59.46,8.54-10.11,8.54-10.11L238.54,179.12,88.47,236.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-4",
    d: "M132.35,203.65S126,230.81,128,247.27c.9,7.67,3,34.61,12.59,59.06,11,28,29.36,53.05,26.36,47.37-8.76-16.61,46.36-142.91,46.36-142.91s26.61-77.91,21.95-81.75-20-2.47-20-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-1",
    d: "M174.77,95s17.08,28.58,26.31,33.68S172.9,206.9,159.3,207.38A58.41,58.41,0,0,1,134,202L156.38,98.55,165.86,84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-scotty-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-6",
    d: "M40.39,63.05S28,73.8,33.22,93.67s13.68,38.77,21.5,44.64S72,153,76.55,160.79s25.42,25.74,37.14,30,12.64,29.67,41.64,16.64,31.35-49.22,31.35-61.6-9.78-50.5-13-56-50.82-70.37-66.79-70.37S40.39,63.05,40.39,63.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-7",
    d: "M150.2,207.21s-12.64,3.58-11.27,15.37S134.55,236,134.55,236l-9.33-31.82s8.89-.28,10.61-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-8",
    d: "M156.76,196.52s-12.43,7.06-6.89,18.62,7.71,16.14,7.71,16.14-24.53,56.32-11.77,86.18c8.29,19.43,21.1,36.24,21.1,36.24s-1.88-40.49,16-71.13c5.24-9-12.28-55.14-12.28-62.61s10.11-27.45,10.11-27.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-7",
    d: "M156.76,196.52s42.56-60.26,44.32-67.85c0,0-6.25-3.71-12.5-13.07,0,0,13.72-6.31,16.46-4.66s11.25,16.18,14.82,17.28,4.66,9.87,1.09,15.91-20.3,53.21-20.3,53.21S166.09,195.15,156.76,196.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-9",
    d: "M132.35,203.65s-1.21,106,32.32,141.73c0,0,3.3-38.33,10.12-59.34s44.68-152.57,39.2-164.3l26.39,7L223,231.79S165.1,313.25,167.4,358.15c0,0-62.43-81.14-63.64-114.75s12.71-40.27,12.71-40.27S126.73,204.18,132.35,203.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-2",
    d: "M214,121.74s16.25.92,14.62,24.13-22.18,148.69,2.6,253.29S319.39,622.56,420.14,633s82-30.29,82-30.29-78.1-220.89-87.43-252c-8.41-28-32.11-123.32-6.23-147,0,0-16.52-27-17.07-39.09s-27-35.23-50.1-31.93-65,6.61-75.43,2.75-26.5-8.13-34.65-13.07S214,121.74,214,121.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-2",
    d: "M120.63,199.32S86.37,305.39,90.09,347.9s7.24,86.48-5,128.89,6.7,129.27,8.23,160.43l-86.91,2S-8.95,521.75,7.91,488,51.85,364.38,47.25,330.15s-2-109.34,16.35-119.56S107.66,180.89,120.63,199.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-2",
    d: "M334.27,174.53s64.87,27.15,74.22,29.18,21.83,11.26,33.72,14.53,24.09,5.95,32.42,16.36,30,55.9,16.65,74.94S452,335.7,433.59,327.38s-63-50.85-89.51-62.75-39.25-29.44-39.25-29.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-10",
    cx: 181.27,
    cy: 390.06,
    r: 5.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-10",
    cx: 185.99,
    cy: 444.19,
    r: 5.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-10",
    cx: 190.01,
    cy: 498.32,
    r: 5.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-11",
    d: "M326.24,175.72a10,10,0,0,1,13.38,2.67c5.95,7.44,9.52,58.88,1.79,64.83s-35.69-2.67-39.26-11.89-4.76-25-2.08-28.85S326.24,175.72,326.24,175.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-1",
    d: "M336.56,195.85a22.51,22.51,0,0,0-3.8-12.11c-2-2.94-4.58-8.49-5.93-18.43-2.37-17.55-2.67-38.36-12.49-40.74s-44.3-16.95-50.85-2.08c0,0-9.51-4.76-9.21,8.32s9.81,27.07,13.38,35.39,10.11,29.74,18.73,31.82,16.36,11.3,19.63,20.82,21.71,3,27.36-7.44C336.07,206.44,336.67,200.6,336.56,195.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-1",
    d: "M34.5,71.53s-11.61,10.08-6.72,28.72S40.61,136.61,48,142.11s16.19,13.74,20.47,21.08,23.83,24.13,34.83,28.11,12.52,21.08,39.71,8.86,28.72-39.42,28.72-51-9.16-47.35-12.22-52.55-47.66-66-62.63-66S34.5,71.53,34.5,71.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-12",
    d: "M10,57.56S11.56,79.46,27.35,79s33.86-29,47.36-32.34,19.35.51,21.13,4.84S96.6,80,108.83,79s15,11.71,18.07,11.71,7.39-.51,8.41-4.84,5.34-20.11,14-17.82,19.35,24.45,25.46,27S161.91,1.57,109.66,0,37.25,42.51,25.34,49.23,10,57.56,10,57.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-scotty-1",
    d: "M140.83,75.81s1.83-18.64,11-17.42,17.11,16.2,17.11,22-.61,25-7.94,24.44S140.83,75.81,140.83,75.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-13 eyeball",
    cx: 89.27,
    cy: 116.44,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-14 pupil",
    cx: 89.27,
    cy: 116.44,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-13 eyeball",
    cx: 52.99,
    cy: 138.46,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-scotty-14 pupil",
    cx: 52.99,
    cy: 138.46,
    r: 7.48
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScotty);
export default __webpack_public_path__ + "static/media/Scotty.ba9b4fe3647bb8f2537ffbbb459e971e.svg";
export { ForwardRef as ReactComponent };